import type { Service } from '@/types/booking';

type ServicePricing = Pick<
  Service,
  'duration' | 'cost' | 'durationRange' | 'costRange'
>;

const hasPositiveRange = (range: Service['costRange']): boolean =>
  (range?.min ?? 0) > 0 && (range?.max ?? 0) > 0;

export function isAddonService(service: ServicePricing): boolean {
  const hasDuration =
    service.duration > 0 || hasPositiveRange(service.durationRange);
  const hasCost = service.cost > 0 || hasPositiveRange(service.costRange);

  return !(hasDuration && hasCost);
}
